module.exports = __webpack_public_path__ + "img/cj.9f27cc48.png";